import type { FunctionComponent } from "react"

import Script from "next/script"

type WonderchatScriptProps = {
  wonderchatKey: string
}

export const WonderchatScript: FunctionComponent<WonderchatScriptProps> = ({ wonderchatKey }) => {
  return (
    <Script
      data-address="app.wonderchat.io"
      data-id={wonderchatKey}
      data-name="wonderchat"
      data-placement="left"
      data-widget-button-size="normal"
      data-widget-size="normal"
      defer
      src="https://app.wonderchat.io/scripts/wonderchat.js"
    />
  )
}
